import { mapGetters } from "vuex";
import { find } from "lodash";

export function HasGroupMixin(groupName) {
    return {
        computed: {
            ...mapGetters("AuthModule", ["currentUser"]),
            ["UserIs" + groupName]() {
                const user = this.currentUser;

                if (!user) {
                    return false; // No User no Groups so cant be!
                }

                return !!find(user.groups || [], {
                    name: groupName,
                });
            },
        },
    };
}
